/** Rótulos das cartas — lógica pura (sem DOM/Preact), testável em unidade. */
import { WEAPONS, type Weapon } from '@rabbit2/shared/data';
import type { Card } from '@rabbit2/shared/sim';

export const weaponName = (id: string): string =>
  WEAPONS.find((w: Weapon) => w.id === id)?.nome ?? id;

export const pretty = (id: string): string =>
  id.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());

export function cardLabel(c: Card): { titulo: string; sub: string; cor: string } {
  const T = { cenoura: '#FF8A3D', luar: '#BFD7EA', vela: '#FFD166', magia: '#7C5CFF' };
  switch (c.kind) {
    case 'new-weapon': return { titulo: weaponName(c.id), sub: 'Nova arma', cor: T.cenoura };
    case 'upgrade-weapon': return { titulo: weaponName(c.id), sub: 'Subir de nível', cor: T.luar };
    case 'evolve': return { titulo: pretty(c.evolucao), sub: '✦ Evolução!', cor: T.vela };
    case 'passive': return { titulo: pretty(c.id), sub: 'Passivo', cor: T.magia };
  }
}
